import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import Discussion from 'src/app/interfaces/Discussion';
import { ForumService } from 'src/app/services/forum.service';
import { LoadingService } from 'src/app/services/loading.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.scss'],
})
export class ForumComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  user;
  locked = false;
  discussions: Array<Discussion> = [];
  filteredDiscussions: Array<Discussion> = [];
  limit = 10;
  params = null;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private forumService: ForumService,
    private loadingService: LoadingService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('forum_view');
    this.loadingService.startLoading();
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.user = u;
          this.locked = false;
          this.forumService.getDiscussions(50).subscribe(
            (d: any) => {
              this.discussions = d;

              // // add dates to comments
              // this.forumService.getAllComments().subscribe((comments: any) => {
              //   this.discussions.forEach((d) => {
              //     if (d.comments && d.comments.length) {
              //         d.comments.forEach((c) => {
              //             comments.forEach((comment) => {
              //                 if (c.id === comment.id) {
              //                     c.timestamp = comment.timestamp;
              //                 }
              //             })
              //         })
              //     }
              //     this.forumService.updateDiscussion(d.id, d);
              //   })
              // })


              this.filteredDiscussions = this.discussions;
              this.loadingService.stopLoading();
              if (this.discussions.length >= 50) {
                this.lazyLoad();
              }
            },
            (e) => console.error(e)
          );
        } else {
          this.locked = true;
          this.loadingService.stopLoading();
        }
      })
    );

  }

  lazyLoad() {
    this.forumService.getAllDiscussions().subscribe((lazyDiscussions) => {
      this.discussions = lazyDiscussions;
      this.filteredDiscussions = this.discussions;
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  filterChange(f) {
    this.filteredDiscussions = f.filteredList;
  }

  trackEvent(name: string): void {
    this.analyticsService.event(name);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let y = window.pageYOffset;
    let max = document.querySelector('.thread-wrap').scrollHeight;
    if (max - 500 <= y) {
      if (this.limit < this.discussions.length) {
        this.limit += 10;
      }
    }
  }
}
